import * as Sentry from '@sentry/react';

/**
 * Initialise Sentry — production builds only.
 *
 * The DSN is baked in at build time via VITE_SENTRY_DSN. Dev builds skip
 * initialisation entirely so no events are reported and no SDK overhead
 * runs locally. Source maps are uploaded automatically by the Sentry
 * Vite plugin during `vite build` (see vite.config.ts).
 */
export function initSentry(): void {
  if (!import.meta.env.PROD) return;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    // Build was made without a DSN — silently skip rather than crash.
    // eslint-disable-next-line no-console
    console.warn('[Sentry] VITE_SENTRY_DSN not set — error reporting disabled.');
    return;
  }

  Sentry.init({
    dsn,
    environment: 'production',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance monitoring — 100% of transactions in prod, mirroring backend.
    tracesSampleRate: 1.0,
    // Session replays — sample 10% of normal sessions, 100% of error sessions.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
